import * as React from 'react'
// components
import { LoaderWithOverlay } from 'components/UI/Loader'
// view components
import EditActivityModal from 'components/Modals/EditActivityModal'
import Content from 'components/Modals/PlanItems/components/ActivitiesList/components/ActivitiesContent'
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
// constants
import { Modals } from 'constants/modals'
// context
import { ActivitiesListAPIContext } from 'containers/Activities/layers/API/ActivitiesList'
// hooks
import { useModalData } from 'hooks/index'
// utils
import { getActivityLabel } from 'utils/activities'

// types
interface IIncomingProps {
  disableDrag?: boolean
}

const ActivitiesList: React.FunctionComponent<IIncomingProps> = ({ disableDrag }) => {
  const { refetch, loading, entity } = React.useContext(ActivitiesListAPIContext)

  const {
    modalData: { activity }
  } = useModalData({ modalType: Modals.CONFIRM_DELETE_ACTIVITY_MODAL })

  return loading ? (
    <LoaderWithOverlay isLoading={loading} />
  ) : (
    <>
      <Content entity={entity} refetch={refetch} disableDrag={disableDrag} />

      <EditActivityModal />

      <ConfirmDeleteModal
        modalType={Modals.CONFIRM_DELETE_ACTIVITY_MODAL}
        header={`Delete ${getActivityLabel(activity)}`}>
        {`Are you sure you want to delete this ${activity && getActivityLabel(activity).toLowerCase()}?`}
      </ConfirmDeleteModal>
    </>
  )
}

export default ActivitiesList
